import get from 'transmute/get';
import { FILTER_VALUES, SORT_ORDER } from './FilterKeyKeyPaths';
export const getFilterValues = get(FILTER_VALUES);
export const getSortOrder = get(SORT_ORDER);